export default __webpack_public_path__ + "static/media/logo1.9d5adf58.png";